import { forwardRef } from "react";
import Collapse from "@mui/material/Collapse";
import type { SlideProps } from "@mui/material/Slide";

type Props = SlideProps & { ownerState?: unknown };

export const RightPanelTransition = forwardRef<HTMLDivElement, Props>(
  ({ direction: _direction, ownerState: _ownerState, ...props }, ref) => (
    <Collapse
      {...props}
      ref={ref}
      orientation="horizontal"
      sx={{ height: "100%" }}
    />
  ),
);
